<template>
  <section id="bi">
    <main style="text-align:left;white-space:normal">
      <div class="title">
        <icontab icoClass='title-ico' selected='bi' />
        {{ $t('bi') }}
      </div>
      <span id="filters">
        <div class="field">
          <label>
            {{ $t('type') }}
          </label>
          <span class="types">
            <input type="radio" id="bar" name="type" style="display:none" value="bar" v-model="type" />
            <label for="bar" value="bar" :class="type == 'bar' ? 'selected' : ''">
              <icon icoClass="opt-ico" selected='bars' />
            </label>
            <input type="radio" id="pie" name="type" style="display:none" value="pie" v-model="type" />
            <label for="pie" value="pie" :class="type == 'pie' ? 'selected' : ''">
              <icon icoClass="opt-ico" selected='pie' />
            </label>
          </span>
        </div>
        <div class="field">
          <label>
            {{ $t('from') }}
          </label>
          <input type="date" v-model="params.date_start" />
        </div>
        <div class="field">
          <label>
            {{ $t('to') }}
          </label>
          <input type="date" v-model="params.date_end" />
        </div>
        <div class="field">
          <label>{{ $t("metric") }}</label>
          <span class="custom-dropdown"><select v-model="metric" @change="resetChart()">
              <option value="trucks">
                {{ $t('trucks') }}
              </option>
              <option value="lines">
                {{ $t('lines') }}
              </option>
              <option value="incidences">
                {{ $t('incidences') }}
              </option>
            </select></span>
        </div>
        <div class="field" v-if="metric != 'trucks'">
          <label>{{ $t("type") }}</label>
          <span class="custom-dropdown"><select v-model="params.type">
              <option :value="undefined">
                {{ $t('both') }}
              </option>
              <option :value="1">
                {{ $t('expeditions') }}
              </option>
              <option :value="2">
                {{ $t('receptions') }}
              </option>
            </select></span>
        </div>
        <button class="btn-green" @click="generate()">{{ $t('ok') }}</button>
        <button class="btn-black" @click="reset()">{{ $t('reset') }}</button>
        <button class="btn-blue btn-100" @click="download()">{{ $t('download_chart') }}</button>
        <button class="btn-blue btn-100" @click="generateWithDatesAndDownload()">{{ $t('download_raw_chart') }}</button>
      </span>
      <span id="chart">
        <bar-chart v-if="type == 'bar'" :chartData="chartdata" :width="300" :height="200" :options="options"
          :values="values" @clicked="fillTable($event)"></bar-chart>
        <pie-chart v-if="type == 'pie'" :chartData="chartdata" :width="300" :height="200" :options="options"
          :values="values" @clicked="fillTable($event)"></pie-chart>
      </span>
      <div v-if="metricDetails.length > 0">
        <table class="custom-table" style="margin: auto">
          <thead>
            <th v-if="metric == 'lines'">{{ $t('booked_date') }}</th>
            <th v-if="metric == 'lines'">{{ $t('loading_date') }}/{{ $t('discharge_date') }}</th>
            <th v-if="metric != 'trucks' && metric != 'users' && metric != 'machines' && metric != 'worktimes'">
              {{ $t('delivery_note') }}</th>
            <th v-if="metric == 'lines'">{{ $t('client') }}</th>
            <th v-if="metric == 'lines'">{{ $t('destination') }}/{{ $t('origin') }}</th>
            <th v-if="metric == 'lines'"><a v-if="auth.isTrw">{{ $t('c_notes_trw') }}</a><a v-else>{{ $t('c_notes') }}</a>
            </th>
            <th v-if="metric == 'lines'"><a v-if="auth.isTrw">{{ $t('k_notes'), [$t(company)] }}</a><a v-else>{{ $t('k_notes') }}</a></th>
            <th v-if="metric == 'lines'"><a v-if="auth.isTrw">{{ $t('virtual_truck') }}</a><a v-else>{{ $t('road') }}</a>
            </th>
            <th v-if="metric == 'lines'">{{ $t('packages') }}</th>
            <th v-if="metric == 'lines'">{{ $t('truck') }}</th>
            <th v-if="metric == 'trucks'">{{ $t('name') }}</th>
            <th v-if="metric == 'trucks'">{{ $t('plate') }}</th>
            <th v-if="metric != 'incidences'"><a v-if="auth.isTrw">{{ $t('arrival_date') }}</a><a v-else>{{ $t('arrival_time') }}</a>
            </th>
            <th v-if="metric == 'trucks'">{{ $t('departure_date') }}</th>
            <th v-if="metric != 'trucks' && metric != 'users' && metric != 'machines' && metric != 'worktimes'">
              {{ $t('status') }}</th>
            <th v-if="metric != 'trucks' && metric != 'users' && metric != 'machines' && metric != 'worktimes'">
              {{ $t('reason') }}</th>
            <th v-if="metric == 'incidences'">{{ $t('date') }}</th>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in metricDetails" :key="index">
              <td v-if="metric == 'lines'">{{ detail.booked_date | moment('D/M/YYYY - HH:mm') }}</td>
              <td v-if="metric == 'lines'">{{ detail.action_date | moment('D/M/YYYY - HH:mm') }}</td>
              <td v-if="metric != 'trucks'">
                <a v-if="metric == 'incidences'"
                  :href="(detail.status == 4 ? '/expedition/' : '/reception/') + detail.shipment.id">{{ detail.shipment.code }}</a>
                <a v-else :href="(detail.type == 1 ? '/expedition/' : '/reception/') + detail.id">{{ detail.code }}</a>
              </td>
              <td v-if="metric == 'lines'">{{ detail.client.description }}</td>
              <td v-if="metric == 'lines'">{{ detail.destination }}</td>
              <td v-if="metric == 'lines'">{{ detail.client_notes }}</td>
              <td v-if="metric == 'lines'">{{ detail.company_notes }}</td>
              <td v-if="metric == 'lines'">{{ detail.road }}</td>
              <td v-if="metric == 'lines'">{{ detail.packages }}</td>
              <td v-if="metric == 'lines'"><a v-if="detail.shipper" :href="'/truck/' + detail.shipper.id">{{ detail.shipper.name }}</a></td>
              <td v-if="metric == 'lines'">{{ detail.own_truck }}</td>
              <td v-if="metric == 'lines'">{{ detail.groupage }}</td>
              <td v-if="metric == 'trucks'">{{ detail.name }}</td>
              <td v-if="metric == 'trucks'">{{ detail.plate }}</td>
              <td v-if="metric != 'incidences'">
                {{ (detail.register_date || detail.arrival_date) | moment('DD/MM/YYYY HH: mm') }}
              </td>
              <td v-if="metric == 'trucks'">{{ detail.expedition_date | moment('DD/MM/YYYY HH:mm') }}</td>
              <td v-if="metric != 'trucks' && metric != 'users' && metric != 'machines' && metric != 'worktimes'">
                {{ detail.status ? $t(detail.status.description + '') : '' }}</td>
              <td v-if="metric != 'trucks' && metric != 'users' && metric != 'machines' && metric != 'worktimes'">
                {{ detail.reason ? $t(detail.reason.description + '') : '' }}</td>
              <td v-if="metric == 'incidences'">{{ detail.created | moment('D/M/YYYY - HH:mm') }}</td>
            </tr>
          </tbody>
        </table>
        <button class="btn-blue button no-width" @click="downloadDetailCsv(metricDetails)">{{ $t('download_raw_detail') }}</button>
      </div>
    </main>
  </section>
</template>

<script>
import jsPDF from 'jspdf'
import BarChart from './../components/BarChart'
import PieChart from './../components/PieChart'
import icontab from './../svg/tabs'
import icon from './../svg/misc'
import JsonExcel from 'vue-json-excel'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'bi',
  components: { icon, icontab, BarChart, JsonExcel, PieChart },
  props: {
  },
  created () {
    this.$emit('loading')
    this.updateModelNames()
  },
  mounted () {
    this.checkBiInfo()
  },
  data () {
    return {
      type: 'bar',
      metric: '',
      params: {},
      labels: [],
      clientsMap: new Map(),
      data: [],
      values: [],
      reasons: [],
      rawReasons: [],
      metricDetails: [],
      rawMetric: [],
      status: new Map(),
      fieldsDetails: [],
      options: {
        legend: { display: false },
        responsive: true,
        backgroundColor: '#443246',
        maintainAspectRatio: true,
        scales: { yAxes: [{ display: true, ticks: { beginAtZero: true } }] }
      },
      model_lines: [
        { field: 'booked_date', name: 'booked_date' },
        { field: 'booked_time', name: 'booked_time' },
        { field: 'action_date', name: 'loading_discharge_date' },
        { field: 'action_time', name: 'loading_discharge_time' },
        { field: 'code', name: 'delivery_note' },
        { field: 'client.description', name: 'origin_destination' },
        { field: 'client_notes', name: 'c_notes' },
        { field: 'company_notes', name: 'k_notes' },
        { field: 'road', name: 'road' },
        { field: 'packages', name: 'packages' },
        { field: 'shipper.name', name: 'truck' },
        { field: 'arrival_date', name: 'arrival_date' },
        { field: 'arrival_time', name: 'arrival_time' },
        { field: 'status.description', name: 'status' },
        { field: 'reason.description', name: 'reason' },
        { field: 'own_truck', name: 'own_truck' },
        { field: 'groupage', name: 'groupage' }
      ],
      model_receptions: [
        { field: 'booked_date', name: 'booked_date' },
        { field: 'booked_time', name: 'booked_time' },
        { field: 'action_date', name: 'discharge_date' },
        { field: 'action_time', name: 'discharge_time' },
        { field: 'client.description', name: 'origin' },
        { field: 'client_notes', name: 'c_notes' },
        { field: 'company_notes', name: 'k_notes' },
        { field: 'packages', name: 'packages' },
        { field: 'shipper.name', name: 'truck' },
        { field: 'arrival_date', name: 'arrival_date' },
        { field: 'arrival_time', name: 'arrival_time' },
        { field: 'status.description', name: 'status' },
        { field: 'reason.description', name: 'reason' },
        { field: 'own_truck', name: 'own_truck' },
        { field: 'groupage', name: 'groupage' }
      ],
      model_expeditions: [
        { field: 'booked_date', name: 'booked_date' },
        { field: 'booked_time', name: 'booked_time' },
        { field: 'action_date', name: 'loading_date' },
        { field: 'action_time', name: 'loading_time' },
        { field: 'code', name: 'delivery_note' },
        { field: 'client.description', name: 'destination' },
        { field: 'client_notes', name: 'c_notes' },
        { field: 'company_notes', name: 'k_notes' },
        { field: 'road', name: 'road' },
        { field: 'packages', name: 'packages' },
        { field: 'shipper.name', name: 'truck' },
        { field: 'arrival_date', name: 'arrival_date' },
        { field: 'arrival_time', name: 'arrival_time' },
        { field: 'status.description', name: 'status' },
        { field: 'reason.description', name: 'reason' },
        { field: 'own_truck', name: 'own_truck' },
        { field: 'groupage', name: 'groupage' }
      ],
      model_incidences_detail: [
        { field: 'shipment.code', name: 'delivery_note' },
        { field: 'status.description', name: 'status' },
        { field: 'reason.description', name: 'reason' },
        { field: 'created', name: 'date' }
      ],
      model_truck: [
        { field: 'name', name: 'name' },
        { field: 'plate', name: 'plate' },
        { field: 'register_date', name: 'register_date' },
        { field: 'expedition_date', name: 'expedition_date' }
      ],
      model_task: [{ field: 'name', name: 'name' }],
      model_user: [{ field: 'name', name: 'name' }],
      model_worktime: [{ field: 'name', name: 'name' }]
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,

      expeditionId: state => state.expeditions.expeditionId,
      receptionId: state => state.receptions.receptionId
    }),
    metricFileName: function () {
      var type = this.params.type ? (this.params.type === this.expeditionId ? 'expeditions' : 'receptions') : ''
      return this.$t(this.metric + '') + this.$t(type) + this.params.date_start + '=' + this.params.date_end
    },
    chartdata: function () {
      return {
        labels: this.labels,
        datasets: [{
          backgroundColor: 'rgba(0, 157, 152, 0.477)',
          data: this.data
        }]
      }
    }
  },
  watch: { },
  methods: {
    ...mapActions({
      getTrucks: 'metrics/trucks',
      getLines: 'metrics/lines',
      getIncidences: 'metrics/incidences',
      getReasons: 'status/reasons',
      getMachines: 'metrics/machines',
      getUsers: 'metrics/taskUsers',
      getRawReasons: 'reasons/list',
      getIncidenceDetails: 'metrics/incidenceDetails',
      getStatus: 'status/list',
      getClients: 'clients/list',
      getTrucksDetail: 'trucks/list',
      getLinesDetail: 'shipments/list'
    }),
    download () {
      var canvas = document.querySelector('#' + this.type + '-chart')
      var canvasImg = canvas.toDataURL('image/png', 1.0)
      // eslint-disable-next-line
      var doc = new jsPDF('landscape')
      doc.addImage(canvasImg, 'PNG', 10, 10, 280, 190)
      doc.save(this.metricFileName + '.pdf')
    },
    downloadCsv (arrData) {
      // eslint-disable-next-line
      if (this.metric == 'lines') {
        this.getJsonFields()

        this.getLinesDetail({
          booked_date_after: new Date(this.params.date_start),
          booked_date_before: new Date(this.params.date_end),
          type: this.params.type,
          page_size: 2000,
          export: true
        }).then((response) => {
          this.downloadDetailCsv(response)
        })
      } else {
        let csvContent = 'data:text/csv;charset=utf-8,'
        csvContent += [
          Object.keys(arrData[0]).map(x => this.$t(x)).join(';'),
          ...arrData.map(item => Object.values(item).join(';'))
        ]
          .join('\n')
          .replace(/(^\[)|(\]$)/gm, '')

        const data = encodeURI(csvContent)
        const link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', this.metricFileName + '.csv')
        link.click()
      }
    },
    buildCsvContent (arrData, fieldsDetails) {
      const escapeValue = (value) => {
        if (value === null || value === undefined) return '--'
        let val = String(value)
        val = val.replace(/"/g, '""')
        return `"${val.replace(/[\r\n]+/g, ' ')}"`
      }

      let csvContent = ''
      let headers = fieldsDetails.map(f => escapeValue(this.$t(f.name))).join(';')
      csvContent += headers + '\n'

      arrData.forEach(row => {
        const line = fieldsDetails.map(field => {
          let value = ''
          if (field.field.includes('.')) {
            value = field.field.split('.').reduce((a, b) => (a && typeof a === 'object' ? a[b] : ''), row)
          } else {
            value = row[field.field]
          }
          return escapeValue(value)
        }).join(';')
        csvContent += line + '\n'
      })

      return csvContent
    },
    downloadDetailCsv (arrData) {
      this.getJsonFields()

      arrData.forEach(row => {
        var auxBooked = row.booked_date ? moment(row.booked_date) : null
        if (auxBooked && auxBooked.isValid()) {
          row.booked_date = auxBooked.format('YYYY-MM-DD')
          row.booked_time = auxBooked.format('HH:mm')
        } else {
          row.booked_date = ''
          row.booked_time = ''
        }

        var auxAction = row.action_date ? moment(row.action_date) : null
        if (auxAction && auxAction.isValid()) {
          row.action_date = auxAction.format('YYYY-MM-DD')
          row.action_time = auxAction.format('HH:mm')
        } else {
          row.action_date = ''
          row.action_time = ''
        }

        var auxArrival = row.arrival_date ? moment(row.arrival_date) : null
        if (auxArrival && auxArrival.isValid()) {
          row.arrival_date = auxArrival.format('YYYY-MM-DD')
          row.arrival_time = auxArrival.format('HH:mm')
        } else {
          row.arrival_date = ''
          row.arrival_time = ''
        }
      })

      const csvContent = this.buildCsvContent(arrData, this.fieldsDetails, this.$t)
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)

      link.setAttribute('href', url)
      link.setAttribute('download', this.metricFileName + '.csv')
      link.style.visibility = 'hidden'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    resetChart () {
      if (this.metric === 'trucks') this.params.type = undefined
      this.metricDetails = []
      this.labels = []
      this.data = []
      this.rawMetric = []
    },
    reset () {
      this.resetChart()
      this.metric = ''
      this.params = {}
    },
    generate () {
      this.getJsonFields()
      this.values = []
      this.metricDetails = []
      if (!this.params.date_start || !this.params.date_end) {
        this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t('fill_dates') })
        return
      }
      var promises = []
      switch (this.metric) {
        case 'trucks':
          promises.push(this.getTrucks(this.params).then((response) => {
            response.sort((a, b) => (a.register_date > b.register_date) ? 1 : -1)
            this.labels = response.map((x) => x.register_date)
            this.data = response.map((x) => x.value)
            this.values = response.map((x) => x.register_date)
            this.rawMetric = response
          }))
          break
        case 'lines':
          promises.push(this.getLines(this.params).then((response) => {
            response.sort((a, b) => (a.booked_date > b.booked_date) ? 1 : -1)
            this.labels = response.map((x) => x.booked_date)
            this.data = response.map((x) => x.value)
            this.values = response.map((x) => x.booked_date)
            this.rawMetric = response
          }))
          break
        case 'incidences':
          promises.push(this.getIncidences(this.params).then((response) => {
            var value = ''
            this.labels = response.map((x) => {
              if (!x.reason) {
                // eslint-disable-next-line
                if (x.status == 4) {
                  value = 'expeditions_incidences'
                  // eslint-disable-next-line
                } else if (x.status == 7) {
                  value = 'delay'
                }
              } else {
                var status = new Map(this.reasons.map(x => [Object.keys(x)[0], x[Object.keys(x)[0]]])) // turns [{status1: []}, {status2: []}] in {status1: [], status2: []}
                var reasons = new Map(status.get('status' + x.status).map(x => [x.code, x.name]))
                value = reasons.get(parseInt(x.reason))
              }
              return this.$t(value)
            })
            this.values = response.map((x) => x.reason)
            this.data = response.map((x) => x.value)
            this.rawMetric = response
          }))
          break
        case 'machines':
          promises.push(this.getMachines(this.params).then((response) => {
            response.sort((a, b) => (a.booked_date > b.booked_date) ? 1 : -1)
            this.labels = response.map((x) => x.machinery)
            this.data = response.map((x) => x.value)
            this.values = response.map((x) => x.booked_date)
            this.rawMetric = response
          }))
          break
        case 'users':
          promises.push(this.getUsers(this.params).then((response) => {
            response.sort((a, b) => (a.booked_date > b.booked_date) ? 1 : -1)
            this.labels = response.map((x) => x.user)
            this.data = response.map((x) => x.value)
            this.values = response.map((x) => x.booked_date)
            this.rawMetric = response
          }))
          break
      }
      return Promise.all(promises).then(() => { return this.rawMetric })
    },
    getJsonFields () {
      if (this.metric === 'lines') {
        this.fieldsDetails = this.model_lines
        if (this.params.type === this.expeditionId) {
          this.fieldsDetails = this.model_expeditions
        } else if (this.params.type === this.receptionId) {
          this.fieldsDetails = this.model_receptions
        }
      }
      if (this.metric === 'trucks') {
        this.fieldsDetails = this.model_truck
      }
      if (this.metric === 'incidences') {
        this.fieldsDetails = this.model_incidences_detail
      }
    },
    fillTable (event) {
      if (this.metric === 'incidences') {
        var params = {}
        if (!event) {
          params = { type: 2 }
        } else {
          params = { reason: event }
        }
        this.getJsonFields()
        this.getIncidenceDetails(Object.assign(params, { date_start: this.params.date_start, date_end: this.params.date_end, page_size: 1000 })).then((response) => {
          this.metricDetails = response
        })
      } else if (this.metric === 'trucks') {
        this.getTrucksDetail({ register_date_after: new Date(event), register_date_before: new Date(event), page_size: 1000 }).then((response) => {
          this.metricDetails = response
        })
      } else if (this.metric === 'lines') {
        this.getLinesDetail({ booked_date_after: new Date(event), booked_date_before: new Date(event), type: this.params.type, page_size: 1000 }).then((response) => {
          this.metricDetails = response
        })
      } else if (this.metric === 'machines') {
        this.getMachines({ booked_date_after: new Date(event), booked_date_before: new Date(event), type: this.params.type, page_size: 1000 }).then((response) => {
          this.metricDetails = response
        })
      } else if (this.metric === 'users') {
        this.getUsers({ booked_date_after: new Date(event), booked_date_before: new Date(event), type: this.params.type, page_size: 1000 }).then((response) => {
          this.metricDetails = response
        })
      } else if (this.metric === 'worktimes') {
        this.getWorktime({ booked_date_after: new Date(event), booked_date_before: new Date(event), type: this.params.type, page_size: 1000 }.then((response) => {
          this.metricDetails = response
        }))
      } else if (this.metric === 'logistic-index') {
        this.getLogisticIndex({ booked_date_after: new Date(event), booked_date_before: new Date(event), type: this.params.type, page_size: 1000 }.then((response) => {
          this.metricDetails = response
        }))
      }
    },
    updateModelNames () {
      const updateNames = (model) => {
        model.forEach(item => {
          if (item.name === 'c_notes') item.name = this.auth.isTrw ? 'c_notes_trw' : 'c_notes'
          if (item.name === 'k_notes') item.name = this.auth.isTrw ? 'k_notes_trw' : 'k_notes'
          if (item.name === 'road') item.name = this.auth.isTrw ? 'virtual_truck' : 'road'
        })
      }

      updateNames(this.model_lines)
      updateNames(this.model_receptions)
      updateNames(this.model_expeditions)
    },
    async checkBiInfo () {
      try {
        this.reasons = await this.getReasons()
        this.rawReasons = new Map((await this.getRawReasons()).map(x => [x.id, x.description]))
        this.status = new Map((await this.getStatus()).map(x => [x.id, x.description]))
        this.clientsMap = new Map((await this.getClients()).map(x => [x.id, x.description]))
      } catch (error) {
        console.error('Error checking permissions and company:', error)
      } finally {
        this.$emit('loaded')
      }
    },
    generateWithDatesAndDownload () {
      if (!this.params.date_start || !this.params.date_end) {
        this.$notify({
          group: 'global',
          type: 'error',
          duration: 4000,
          title: 'Warning',
          text: this.$t('fill_dates')
        })
        return
      }

      this.generate().then(() => {
        this.downloadCsv(this.rawMetric)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/variables.scss";

.custom-dropdown select {
  min-width: 100%;
}

#filters {
  width: 25%;
  display: inline-block;
}

#chart {
  min-width: 500px;
  width: 70%;
  display: inline-block;
}

#bi {
  display: table;
}

#filters {
  vertical-align: top;
  display: inline-block;
  padding: 1em;

  input {
    width: 100%;
    box-sizing: border-box;
  }
}

.btn-green,
.btn-black {
  width: 47%;
  margin: 1%;
}

.no-width {
  display: inline-block;
}

.btn-blue {
  box-sizing: border-box;
  text-align: center;
}

.btn-100 {
  margin: 1%;
  width: 98%;
}

.types {
  label {
    display: inline-block;
    width: 50%;
    background: white;
    border: 1px solid lightgrey;
    box-sizing: border-box;
    text-align: center;
    transition: .2s;
    fill: $k-black;

    &:hover {
      // background: gainsboro;
      box-shadow: inset 0px 0px 5px 3px rgba($color: #000, $alpha: .1);
    }
  }

  :nth-child(2) {
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }

  :nth-child(4) {
    border-bottom-right-radius: 7px;
    border-top-right-radius: 7px;
  }
}

.selected {
  background: $k-black !important;
  fill: white !important;
  border-color: $k-black !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageBi.vue